var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail_luk"},[_c('div',{staticClass:"content"},[_c('video',{ref:"video",attrs:{"src":_vm.detail.videoPath,"poster":_vm.detail.sharImage,"controls":""},on:{"pause":_vm.onPause,"play":_vm.onPlay}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }